<template lang="pug">
.k-form( :class=`{ loading: isLoading }`)
  .form-body
    slot
  transition( name='fade' appear )
    d-loading( v-if='isLoading && !isMainLoading' )
</template>

<script lang="js">
import isArray from 'lodash-es/isArray'
import { mapState, mapGetters } from 'vuex'
import DLoading from '@/displays/d-loading'

export default {
  name: 'FormBlock',
  mixins: [],
  components: { DLoading },
  props: {
    loader: [ String, Array ]
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    ...mapState([ 'loading' ]),
    ...mapGetters([ 'isMainLoading' ]),
    loaders() {
      return isArray( this.loader ) ? this.loader
         : ( this.loader && this.loader.trim().split(/\s*,\s*/) )
    },
    isLoading() {
      return !!( this.loaders && this.loaders.find( l => this.loading[l] ))
    }
  }
}
</script>

<style lang="scss">
.k-form {
  position: relative;
  .d-loading {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: var(--bg-loader-form, transparent);
    border-radius: var(--br-loader-form ,var(--br-loader, 4px))
  }
  .form-body {
    transition: 400ms;
  }
  &.loading {
    .form-body {
      transition: 1500ms;
      opacity: 0.2;
    }
  }
}
</style>
